import React,{useState}  from 'react'
import {Box,Typography,Container,Button, TextField, InputAdornment, InputLabel, Input, FormControlLabel, RadioGroup, Radio, Divider} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowIcon from '@mui/icons-material/ArrowBackRounded';
import CircularProgress from '@mui/material/CircularProgress';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import {IconButton} from "@mui/material"
import {useNavigate} from 'react-router-dom'
import Header from '../Components/Header'
import FormControl from '@mui/material/FormControl';
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import { Alarm,Twitter,LinkedIn,Facebook,Reddit,Instagram,  ArrowDropDown, ArrowDropDownCircleOutlined, ArrowDropUp,  Group, Search, SearchOutlined, Visibility, WhatsApp, Telegram, Email } from '@mui/icons-material';
import { add_job } from '../Redux/jobSlice';
import { CalendarIcon } from '@mui/x-date-pickers';
import {
	EmailShareButton,
	FacebookShareButton,
	InstapaperShareButton,
	LinkedinShareButton,
	RedditShareButton,
	TelegramShareButton,
	TwitterShareButton,
	WhatsappShareButton
  } from "react-share";

  const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black"
}));

const SearchBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 10,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 10
    },
	background:theme.palette.mode === 'dark'? '#100101' : 'white',
	flexDirection:"row",
	display:"flex",
	justifyContent:"space-between",
	alignItems:"center",
	borderRadius:10,
	margin:10,
	width:"50%"
}));

const BodyBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 5,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
	background:theme.palette.mode === 'dark'? '#100101' : 'white',
	flexDirection:"row",
	display:"flex",
	justifyContent:"space-between",
	alignItems:"flex-start",
	borderRadius:5,
	minHeight:450,
	maxHeight:450,
	margin:5
}));

const SideBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 5,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
	background:theme.palette.mode === 'dark'? '#100101' : 'white',
	justifyContent:"flex-start",
	alignItems:"flex-start",
	width:"25%",
	minHeight:400,
	maxHeight:400
}));

const MainBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 5,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
	background:theme.palette.mode === 'dark'? '#100101' : 'white',
	justifyContent:"flex-start",
	alignItems:"flex-start",
	borderRadius:10,
	margin:10,
	width:"75%",
	minHeight:400,
	maxHeight:400
}));

const HeaderBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 7,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
	background:theme.palette.mode === 'dark'? 'black' : 'white',
}));

const ContentBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 7,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
	background:theme.palette.mode === 'dark'? "#000" : 'white',
    maxHeight:250,
    minHeight:250,
	marginTop:10
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownCircleOutlined sx={{ fontSize: 20 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginBottom: theme.spacing(1),
	},
	borderRadius:10,
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 7,
        backgroundColor: '#000000'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
	borderRadius:10,
    maxHeight:80,
    minHeight:50
}));

const MyJobs = ()=>{

	const theme = useTheme()
	const test = useSelector(state => state?.test.test);
	const navigate = useNavigate()
	const [lang, setLang] = useState(test?.language);
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [showDialog, setShowDialog] = React.useState(false);
	const [isNext, setIsNext] = React.useState(false);
    const [expand, setExpand] = React.useState(true);
	const [message, setMessage] = React.useState("");
	const [participants, setParticipants] = React.useState([]);
	const user = useSelector(state => state?.auth.user);
    const [search, setSearch] = React.useState("");
    const [filter, setFilter] = React.useState("");
	const [field, setField] = React.useState("");
	const [location, setLocation] = React.useState(null);
	const [type, setType] = React.useState(null);
	const [category, setCategory] = React.useState(null);
    const [searching, setSearching] = React.useState(false);
	const [data, setData] = React.useState([]);
	const [select, setSelect] = React.useState(0);
	const recorder = React.useRef(null)
	const [showConfirm, setShowConfirm] = React.useState(false);
	const [fetching, setFetching] = React.useState(false);
	const [filtering, setFiltering] = React.useState(false);
	const [viewing, setViewing] = React.useState(false);
	const [content, setContent] = React.useState("");
	const [showContent, setShowContent] = React.useState(false);
	const [selected, setSelected] = React.useState(0);
	const dispatch = useDispatch()



const handleExpand = ()=>{
    try {
        setExpand(prev=>!prev)
    } catch (error) {
        console.log(error)
    }
}

const handleGetJob = async (id,isView,index)=>{
    try {

		if (isView) {
			setViewing(true)
		}else{
			setFetching(true)
		}
		setSelect(index)

		const data = {
			email:user?.email,
			id:id
		}

        const getJob = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/user/get-job/`,data,{
			headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${user?.accessToken}`
            }
		}).catch(err=>{
			console.log(err)
			setFetching(false)
			setViewing(false)
			setMessage("please,check your connection and try again")
			setOpen(true)
		})

		if (getJob?.status == 200 && getJob?.data?.success) {
			dispatch(add_job(getJob?.data?.job))
			if (isView) {
				navigate("/jobInfo")
			} else {
				navigate("/jobApplication")
			}
		}else{
			setMessage(getJob?.data?.message)
			setOpen(true)
		}
		if (isView) {
			setViewing(false)
		}else{
			setFetching(false)
		}
    } catch (error) {
        console.log(error)
    }
}

const handleGetJobs = async ()=>{
    try {

		setLoading(true)

		const data = {
			email:user?.email
		}

        const getJobs = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/user/get-my-jobs/`,data,{
			headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${user?.accessToken}`
            }
		}).catch(err=>{
			setLoading(false)
			setMessage("please,check your connection and try again")
			setOpen(true)
		})

		if (getJobs?.status == 200 && getJobs?.data?.success) {
			// setPublicData(getJobs?.data.publicTemplates)
			setData(getJobs?.data.jobs)
			// console.log(getJobs?.data)
		}
		setLoading(false)
    } catch (error) {
        console.log(error)
    }
}

const handleFilter = async ()=>{
    try {
		setFiltering(true)

		const data = {
			email:user?.email,
			search:search !== "" ? search : null,
			field:field !== "" ? field : null,
			type:type !== "" ? type : null,
			category:category !== "" ? category : null,
			location:location !== "" ? location : null,
		}

		console.log(data)

		const getJobs = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/user/filter-my-jobs/`,data,{
			headers:{
				"Content-Type":"application/json",
				"Authorization":`Bear ${user?.accessToken}`
			}
		}).catch(err=>{
			setFiltering(false)
			setMessage("please,check your connection and try again")
			setOpen(true)
		})

		if (getJobs?.status == 200 && getJobs?.data?.success) {
			// setPublicData(getJobs?.data.publicTemplates)
			setData(getJobs?.data.jobs)
			// console.log(getJobs?.data)
		}
		setFiltering(false)
    } catch (error) {
        console.log(error)
    }
}

const handleSearch = async ()=>{
    try {

		if (search !== "") {
			setSearching(true)

			const data = {
				email:user?.email,
				search:search
			}

			console.log(data)
	
			const getJobs = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/user/search-my-jobs/`,data,{
				headers:{
					"Content-Type":"application/json",
					"Authorization":`Bear ${user?.accessToken}`
				}
			}).catch(err=>{
				setSearching(false)
				setMessage("please,check your connection and try again")
				setOpen(true)
			})
	
			if (getJobs?.status == 200 && getJobs?.data?.success) {
				// setPublicData(getJobs?.data.publicTemplates)
				setData(getJobs?.data.jobs)
				// console.log(getJobs?.data)
			}
			setSearching(false)
		} else {
			setMessage("please,write something to search a job")
			setOpen(true)
		}
    } catch (error) {
        console.log(error)
    }
}

const handleSnackbarClose = ()=>{
	setOpen(false)
}
React.useLayoutEffect(()=>{
	handleFilter()
},[category,location,type,filter])

React.useEffect(()=>{
	handleGetJobs()
},[])

	return(
		<Box width="100%" mt={1}>
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" href="/dashboard">
						Dashboard
					</Link>
					<Typography sx={{fontSize:12,color:"gray"}}>Jobs</Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
				<HeaderBox>
					<Box sx={{flexDirection:"row",display:"flex",justifyContent:"space-between",alignItems:"center",width:"90%",ml:3,mt:1}}>
						<Box sx={{flexDirection:"row",display:"flex",justifyContent:"space-between",alignItems:"center",width:"50%"}}>
							<IconButton onClick={(e)=>{
								e?.preventDefault()
								navigate("/dashboard")
							}}>
								<img width={25} height={25} style={{marginRight:4}} src={require('../assets/test.png')}/>
								<Typography
									variant="h6"
									noWrap
									component="div"
									sx={{ display: { xs: 'none', sm: 'block' ,fontSize:25,marginLeft:1,fontFamily:"zolla"} }}
								>
									iTest
								</Typography>
							</IconButton>
							<Box sx={{flexDirection:"row",display:"flex",justifyContent:"space-evenly",alignItems:"center",width:"50%"}}>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									navigate("/jobs")
								}} sx={{borderRadius:1}}>
									<Typography sx={{fontSize:13}}>
										Find Offer
									</Typography>
								</IconButton>
								{
									user?.auth && (
										<>
											<IconButton onClick={(e)=>{
												e?.preventDefault()
												navigate("/addJob")
											}} sx={{borderRadius:1}}>
												<Typography sx={{fontSize:13}}>
													Post Offer
												</Typography>
											</IconButton>
											<IconButton onClick={(e)=>{
												e?.preventDefault()
												navigate("/myJobs")
											}} sx={{borderRadius:1,background:"#ff0",color:"#000"}}>
												<Typography sx={{fontSize:13}}>
													My Offers
												</Typography>
											</IconButton>										
										</>

									)
								}
							</Box>
						</Box>
						{
							user?.auth && (
							<IconButton onClick={(e)=>{
								e?.preventDefault()
								navigate("/profile")
							}} sx={{borderRadius:1,background:"#fff"}}>
								<img width={25} height={25} style={{borderRadius:20}} src={user?.profile !== "https://" ? user?.profile : require("../assets/avatar.jpg")}/>
								<Typography sx={{fontSize:13,marginLeft:1,color:"#000" }}>
									{user?.first_name}
								</Typography>
							</IconButton>								
							)
						}
					</Box>
					<Typography sx={{fontSize:18,ml:3,mt:3,fontFamily:"dinofans"}}>
						My Offers dashboard
					</Typography>
					<SearchBox sx={{mt:1,width:{xs:"90%",md:"50%"}}}>
							<Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" alignContent="center" ml={2}>
								<SearchOutlined sx={{mr:3}}/>
								<input
									onChange={(e)=>{setSearch(e.target.value)}}
									placeholder='Offer Title...'
									type="text"
									style={{height:50,minWidth:280,borderWidth:0,fontSize:15,backgroundColor:"transparent",color:"#fff",marginLeft:5}}
									value={search}
								/>
							</Box>
							<IconButton onClick={(e)=>{
								e?.preventDefault()
								handleSearch()
							}} disabled={searching} sx={{background:"#FFC107",m:1,borderRadius:1,display:{xs:"none",md:"inline-block"}}}>
								{
									searching ? 
									<CircularProgress size={15} sx={{color:"#fff"}}/> 
								: 
									<Typography sx={{color:"#000",fontSize:12,fontFamily:"dinofans"}}>
										Search
									</Typography>
								}
							</IconButton>
					</SearchBox>
				</HeaderBox>
				<BodyBox>
					<SideBox sx={{p:2,display:{xs:"none",md:"inline-block"}}}>
						<Typography sx={{fontSize:14,fontFamily:"dinofans"}}>
							Filter
						</Typography>
						<Box>
							<TextField
								placeholder='ex: IT...'
								type='Field'
								style={{marginTop:5}}
								sx={{color:"#fff",}}
								InputProps={{
									endAdornment: (
									<InputAdornment  style={{justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
										<Search/>
									</InputAdornment>
									)
								}}
								label="field"
								value={field}
								onChange={(e)=>{setField(e.target.value)}}
							/>
						</Box>
						<Box justifyContent="center" alignItems="center" width="100%" m={1}>
							<Typography sx={{color:"#ff0",fontSize:12}}>
								Offer type
							</Typography>
							<FormControl>
								<RadioGroup
									value={type}
									aria-labelledby="demo-row-radio-buttons-group-label"
									name="row-radio-buttons-group"
									>
									<FormControlLabel value="" control={<Radio sx={{fontSize:10,color:"#ff0"}} onClick={()=>{
										setType("")
									}} />} label={<Typography  sx={{fontSize:12}}>Whatever</Typography>} />
									<FormControlLabel value="Job" control={<Radio sx={{fontSize:10,color:"#ff0"}} onClick={()=>{
										setType("Job")
									}} />} label={<Typography  sx={{fontSize:12}}>Job</Typography>} />
									<FormControlLabel value="Internship" control={<Radio sx={{fontSize:10,color:"#ff0"}} onClick={()=>{
										setType("Internship")
									}} />} label={<Typography  sx={{fontSize:12}}>Internship</Typography>} />
									<FormControlLabel value="voluntarism" control={<Radio sx={{fontSize:10,color:"#ff0"}} onClick={()=>{
										setType("voluntarism")
									}} />} label={<Typography  sx={{fontSize:12}}>Voluntarism</Typography>} />
								</RadioGroup>                        
							</FormControl>
							<Divider sx={{mt:1}}/>
						</Box> 
						<Box justifyContent="center" alignItems="center" width="100%" m={1}>
							<Typography sx={{color:"#ff0",fontSize:12}}>
								Offer Location
							</Typography>
							<FormControl>
								<RadioGroup
									value={location}
									aria-labelledby="demo-row-radio-buttons-group-label"
									name="row-radio-buttons-group"
									>
									<FormControlLabel value="" control={<Radio sx={{fontSize:10,color:"#ff0"}} onClick={()=>{
										setLocation("")
									}} />} label={<Typography  sx={{fontSize:12}}>Wherever</Typography>} />
									<FormControlLabel value="On-site" control={<Radio sx={{fontSize:10,color:"#ff0"}} onClick={()=>{
										setLocation("On-site")
									}} />} label={<Typography  sx={{fontSize:12}}>On-site</Typography>} />
									<FormControlLabel value="Remote" control={<Radio sx={{fontSize:10,color:"#ff0"}} onClick={()=>{
										setLocation("Remote")
									}} />} label={<Typography  sx={{fontSize:12}}>Remote</Typography>} />
									<FormControlLabel value="Hybrid" control={<Radio sx={{fontSize:10,color:"#ff0"}} onClick={()=>{
										setLocation("Hybrid")
									}} />} label={<Typography  sx={{fontSize:12}}>Hybrid</Typography>} />
								</RadioGroup>                        
							</FormControl>
							<Divider sx={{mt:1}}/>
						</Box>
						<Box justifyContent="center" alignItems="center" width="100%" m={1}>
							<Typography sx={{color:"#ff0",fontSize:12}}>
								Offer category
							</Typography>
							<FormControl>
								<RadioGroup
									value={category}
									aria-labelledby="demo-row-radio-buttons-group-label"
									name="row-radio-buttons-group"
									>
									<FormControlLabel value="" control={<Radio sx={{fontSize:10,color:"#ff0"}} onClick={()=>{
										setCategory("")
									}} />} label={<Typography  sx={{fontSize:12}}>Whatever</Typography>} />
									<FormControlLabel value="Full-time" control={<Radio sx={{fontSize:10,color:"#ff0"}} onClick={()=>{
										setCategory("Full-time")
									}} />} label={<Typography  sx={{fontSize:12}}>Full-time</Typography>} />
									<FormControlLabel value="Part-time" control={<Radio sx={{fontSize:10,color:"#ff0"}} onClick={()=>{
										setCategory("Part-time")
									}} />} label={<Typography  sx={{fontSize:12}}>Part-time</Typography>} />
									<FormControlLabel value="Contract" control={<Radio sx={{fontSize:10,color:"#ff0"}} onClick={()=>{
										setCategory("Contract")
									}} />} label={<Typography  sx={{fontSize:12}}>Contract</Typography>} />
								</RadioGroup>                        
							</FormControl>
						</Box>  
					</SideBox>
					<MainBox sx={{p:1}}>
						{
							(data?.length == 0 && !loading) &&
								<Box textAlign="center" alignContent="center" justifyContent="center" mt={10}>
									<Box justifyContent="center" alignItems="center" mt={10}>
										<img  width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
									</Box>
									<Typography sx={{fontSize:12}}>
										Offers could not be found
									</Typography>
								</Box>
						}
						{
						(data?.length == 0 && loading) &&
								<Box textAlign="center" alignContent="center" justifyContent="center" mt={2} mb={5}>
									<CircularProgress size={20} sx={{color:"#fff"}}/>
								</Box>
						}
						{
							data?.length > 0  &&
								<Typography sx={{fontSize:14,fontFamily:"dinofans"}}>
									{data?.length} available Jobs 
								</Typography>
						}
						{
							filtering &&
								<CircularProgress size={15} sx={{color:"#ff0"}}/>
						}
						{
							data?.map((item,index)=>(
								<Box mt={2} key={index} sx={{background:"#000",borderRadius:2,p:1}}>
								<Box sx={{"&hover":{backgroundColor:"gray"}}}  display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between" alignItems="center" width="100%" >
									<img resizemode="cover" src={item?.enterprise_logo} width={35} height={35} style={{borderRadius:5,marginRight:5}}/>
									<Box width={150} justifyContent="center" alignItems="center">
										<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
											{item?.title}
										</Typography>
										<Typography sx={{fontSize:11}}>
											{item?.enterprise_name?.toLocaleUpperCase()}
										</Typography>
									</Box>
									<Typography sx={{fontSize:12,p:1,mt:{xs:1},color:"#000",fontWeight:"bold",backgroundColor:"gray",borderRadius:1,width:100,textAlign:"center"}}>
										{item?.type}
									</Typography>
									<IconButton sx={{p:1,mt:{xs:1},color:"#000",fontWeight:"bold",backgroundColor:"gray",borderRadius:1,width:100,textAlign:"center"}}>
										<Typography sx={{fontSize:12,mr:1}}>
											{item?.applicants?.length}
										</Typography>
										<Group fontSize='small'/>
									</IconButton>
									<IconButton sx={{p:1,mt:{xs:1},backgroundColor:"#000",borderRadius:1,width:100,textAlign:"center"}}>
										<CalendarIcon fontSize='small' sx={{color:"red"}}/>
										<Typography sx={{fontSize:11,color:"red",fontWeight:"bold"}}>
											{item?.deadline}
										</Typography>
									</IconButton>
									<IconButton onClick={async (e)=>{
										e?.preventDefault()
										await handleGetJob(item?.id,true,index)
									}} disabled={viewing} sx={{p:1,mt:{xs:1},backgroundColor:"#ff0",borderRadius:1,width:100,textAlign:"center"}}>
										{
										(viewing && select == index) ? 
											<CircularProgress sx={{color:"#fff"}} size={15}/>
										: 
											<Typography sx={{fontSize:12,color:"#000",fontWeight:"bold"}}>
												View
											</Typography>
										}
									</IconButton>
									<IconButton onClick={()=>{
										setSelected(index)
										setShowContent(prev=>!prev)
									}} sx={{width:50,textAlign:"center",borderRadius:1}}>
										{
											showContent ? <ArrowDropUp/> : <ArrowDropDown/>
										}
									</IconButton>
								</Box>
								{
									(selected == index && showContent) && (
										<ContentBox>
											<Box flexWrap="wrap" width="100%" display="flex" flexDirection="row" mt={1} p={1}>
												<Box width="25%" >
													<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
														Location
													</Typography>
													<Typography sx={{marginBottom:1,fontSize:11}}>
														{item?.location}
													</Typography>
												</Box>
												<Box width="25%">
													<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
														Category
													</Typography>
													<Typography sx={{marginBottom:1,fontSize:11}}>
														{item?.category}
													</Typography>
												</Box>
												<Box width="25%">
													<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
														Organization
													</Typography>
													<Typography sx={{marginBottom:1,fontSize:11}}>
														{item?.enterprise_name?.toLocaleUpperCase()}
													</Typography>
												</Box>
												<Box width="25%">
													<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
														Organization Email
													</Typography>
													<Typography sx={{marginBottom:1,fontSize:11}}>
														{item?.enterprise_email}
													</Typography>
												</Box>
												<Box m={1} justifyContent="center" alignItems="center" width="45%">
													<Accordion sx={{width:{xs:"100%",md:"95%"}}} expanded={expand} onChange={handleExpand}>
														<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
															<Typography sx={{fontFamily:"dinofans",fontSize:13}}>
															Benefits
															</Typography>
														</AccordionSummary>
														<AccordionDetails >
															<ol>
																{
																	item?.benefits?.map((itm,index)=>(
																		<li style={{color:"#fff",fontSize:12}} key={index}>
																			{itm}
																		</li>
																	))
																}
															</ol>
														</AccordionDetails>
													</Accordion>
												</Box>
												<Box m={1} justifyContent="center" alignItems="center" width="45%">
													<Accordion sx={{width:{xs:"100%",md:"95%"}}} expanded={expand} onChange={handleExpand}>
														<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
															<Typography sx={{fontFamily:"dinofans",fontSize:13}}>
																Eligibilities
															</Typography>
														</AccordionSummary>
														<AccordionDetails >
															<ol>
																{
																	item?.eligibilities?.map((itm,index)=>(
																		<li style={{color:"#fff",fontSize:12}} key={index}>
																			{itm}
																		</li>
																	))
																}
															</ol>
														</AccordionDetails>
													</Accordion>
												</Box>
											</Box>
											<Box width="100%" ml={1}>
												<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
													Description
												</Typography>
												<Typography sx={{marginBottom:1,fontSize:11}}>
													{item?.description}
												</Typography>
											</Box>
											<Box width="100%"  ml={1}>
												<Typography sx={{fontFamily:"dinofans",fontSize:12}}>
													Organization description
												</Typography>
												<Typography sx={{marginBottom:1,fontSize:11}}>
													{item?.enterprise_description}
												</Typography>
											</Box>
											<Box sx={{width:{xs:"100%",md:"50%"}}} textAlign="left" flexWrap="wrap" flexDirection="row" display="flex" justifyContent="space-evenly" alignItems="center">
												<IconButton onClick={async (e)=>{
													e?.preventDefault()
													navigator.clipboard.writeText(`https://itest-mocha.vercel.app/job/${item?.id}`)
													// navigator.clipboard.writeText(`https://itest-mocha.vercel.app/jobs/${item?.id}`)
													setMessage("link copied")
													setOpen(true)
												}} sx={{p:1,m:2,backgroundColor:"#fff",borderRadius:1,textAlign:"center"}}>
													<Typography sx={{fontSize:12,color:"#000",fontWeight:"bold"}}>
														Copy link
													</Typography>
												</IconButton>
												<FacebookShareButton  url={`https://itest-mocha.vercel.app/job/${item?.id}`} hashtag="#opportinitties">
													<Facebook fontSize='small' sx={{color:"#ff0"}}/>
												</FacebookShareButton>
												<InstapaperShareButton url={`https://itest-mocha.vercel.app/job/${item?.id}`}>
													<Instagram fontSize='small' sx={{color:"#ff0"}}/>
												</InstapaperShareButton>
												<LinkedinShareButton summary={item?.description} url={`https://itest-mocha.vercel.app/job/${item?.id}`} title='my job'>
													<LinkedIn fontSize='small' sx={{color:"#ff0"}}/>
												</LinkedinShareButton>
												<RedditShareButton title={`${item?.name}`} url={` https://itest-mocha.vercel.app/job/${item?.id}`}>
													<Reddit fontSize='small' sx={{color:"#ff0"}}/>
												</RedditShareButton>
												<TelegramShareButton title={item?.name} url={`https://itest-mocha.vercel.app/job/${item?.id}`}>
													<Telegram fontSize='small' sx={{color:"#ff0"}}/>
												</TelegramShareButton>
												<EmailShareButton subject={item?.name} body={item?.description} url={`https://itest-mocha.vercel.app/job/${item?.id}`}>
													<Email fontSize='small' sx={{color:"#ff0"}}/>
												</EmailShareButton>
												<TwitterShareButton title={item?.name} url={`https://itest-mocha.vercel.app/job/${item?.id}`} hashtags={["#opportunities","#apply","#job","internship"]}>
													<Twitter fontSize='small' sx={{color:"#ff0"}}/>
												</TwitterShareButton>
												<WhatsappShareButton url={`https://itest-mocha.vercel.app/job/${item?.id}`} title={`${item?.name}- apply to https://itest-mocha.vercel.app/job/${item?.id}`}>
													<WhatsApp fontSize='small' sx={{color:"#ff0"}}/>
												</WhatsappShareButton>
											</Box>
										</ContentBox>
									)
								}
							</Box>
							))
						}
					</MainBox>
				</BodyBox>
			</Container>
		</Box>
		)
}

export default MyJobs